import { SuggestionsFilterType } from "draft-js-mention-plugin";
import * as React from "react";
import { Mention } from "../types/types";
import { suggestionsFilter } from "../utils/suggestionsFilter";

export const useSuggestions = <T>(
    availableMentions: Mention[],
    isOpenedRef: React.MutableRefObject<boolean>,
    filter: (searchValue: string, suggestions: Mention[]) => T[] | Mention[] = suggestionsFilter
) => {
    /*
     * MentionSuggestions component opens popup whenever suggestions prop is changed and there is at least
     * one item in suggestions array.
     * So if we update suggestions when available mentions updated (reloaded) then popup will be opened even
     * if there is no focus in message input.
     *
     * To overcome this issue we should update suggestions list after
     *   - search changed
     *   - available mentions changed and popup is opened currently
     *   - when popup is opening (for case when search was not changed but available mentions where updated
     *             when popup was closed)
     *
     */
    const [suggestions, setSuggestions] = React.useState([]);

    const [search, setSearch] = React.useState("");

    const isOpened = isOpenedRef.current;

    const onSearchChange = ({ value }: SuggestionsFilterType) => {
        setSearch(value);
        // update suggestions list for each search change
        setSuggestions(filter(value, availableMentions));
    };

    React.useEffect(() => {
        // update suggestions if available mentions changed ,
        // and when project members changed
        // and when popup is opened.
        if (isOpened) {
            setSuggestions(filter(search, availableMentions));
        }
    }, [isOpened, availableMentions, filter, search]);

    return {
        suggestions,
        onSearchChange,
    } as const;
};
